import React from "react";

import Icon from "../../../../../components/icon";

import * as S from "../../styles";

import IProps from "./props";

import { calculateClassName } from "../utils/calculate-class-name";

const PlanFeatureMobile: React.FC<IProps> = ({ feature, index }) => (
  <S.MobileRow className={calculateClassName(index, "middle")}>
    {feature.name}
    {feature.included !== undefined && (
      <Icon
        name={feature.included ? "checkbox-circle" : "close-circle"}
        className={calculateClassName(index, "middle")}
      />
    )}
    {feature.value && <span>{feature.value}</span>}
  </S.MobileRow>
);

export default PlanFeatureMobile;
